import { action, observable, runInAction } from "mobx";
import { api } from "../../api";
import { IFornecedor } from "../../model";
import { IConta } from "../../model";
import { toast } from "react-toastify";

export class _FornecedoresStore {
  obs = observable({
    fornecedores: [] as IFornecedor[],
    clientes: [] as IFornecedor[],
    Fornecedor: null as IFornecedor,
    Cliente: null as IFornecedor,
    atividadesPrincipais: [] as any[],
    atividadesSecundarias: [] as any[],
    viewFornecedor: false as boolean,
    waitFornecedores: false as boolean,
    filter: "" as string,
    currentPage: 1 as number,
    clientes_length: 0 as number,
    fornecedores_length: 0 as number,
  })

  @action
  async viewFornecedorReq(row: any): Promise<void> {
    try {
      this.obs.atividadesPrincipais = [];
      this.obs.atividadesSecundarias = [];

      let resp = await api.get(`/api/view-fornecedor/${row.cipher_id}`);

      for (let i = 0; i < resp.data.atividade_principal.length; i++) {
        var ativiPrin = resp.data.atividade_principal[i].code + " - " +
          resp.data.atividade_principal[i].text;
        this.obs.atividadesPrincipais.push(ativiPrin);
      }

      for (let i = 0; i < resp.data.atividades_secundarias.length; i++) {
        var ativiSec = ""
        if (resp.data.atividades_secundarias[i].codigo) {
          ativiSec = resp.data.atividades_secundarias[i].codigo + " - " + resp.data.atividades_secundarias[i].descricao;
        } else {
          ativiSec = resp.data.atividades_secundarias[i].code + " - " + resp.data.atividades_secundarias[i].text;
        }
        this.obs.atividadesSecundarias.push(ativiSec);
      }

      runInAction(() => {
        this.obs.Fornecedor = resp.data;
      });
    } catch (ex) {
      toast.error('Erro ao visualizar Fornecedor, tente novamente mais tarde.', {});
    }
  }

  @action
  async viewClienteReq(row: any): Promise<void> {
    try {
      this.obs.atividadesPrincipais = [];
      this.obs.atividadesSecundarias = [];

      let resp = await api.get(`/api/view-fornecedor/${row.cipher_id}`);

      for (let i = 0; i < resp.data.atividade_principal.length; i++) {
        var ativiPrin = resp.data.atividade_principal[i].code + " - " +
          resp.data.atividade_principal[i].text;
        this.obs.atividadesPrincipais.push(ativiPrin);
      }

      for (let i = 0; i < resp.data.atividades_secundarias.length; i++) {
        var ativiSec = ""
        if (resp.data.atividades_secundarias[i].codigo) {
          ativiSec = resp.data.atividades_secundarias[i].codigo + " - " + resp.data.atividades_secundarias[i].descricao;
        } else {
          ativiSec = resp.data.atividades_secundarias[i].code + " - " + resp.data.atividades_secundarias[i].text;
        }
        this.obs.atividadesSecundarias.push(ativiSec);
      }

      runInAction(() => {
        this.obs.Cliente = resp.data;
      });
    } catch (ex) {
      toast.error('Erro ao visualizar Cliente, tente novamente mais tarde.', {});
    }
  }

  @action
  async loadFornecedores(page: number, text: string) {
    try {
      this.obs.waitFornecedores = true;
      let params = {
        page: page,
        limit: 20,
        filter: text
      }
      let resp = await api.post("/api/fornecedores", params);

      this.obs.fornecedores = [];
      this.obs.fornecedores_length = 0

      if (resp.data.itens.length > 0) {
        this.obs.fornecedores_length = resp.data.count
        this.obs.fornecedores = resp.data.itens
      }

      this.obs.waitFornecedores = false;

    } catch (ex) {
      this.obs.waitFornecedores = false;
      toast.error('Erro ao carregar Fornecedores, tente novamente mais tarde.', {});
    }
  }

  @action
  async loadClientes(page: number, text: string) {
    try {
      this.obs.waitFornecedores = true;

      let params = {
        page: page,
        limit: 20,
        filter: text
      }
      let resp = await api.post("/api/clientes", params);

      this.obs.clientes = [];
      this.obs.clientes_length = 0

      if (resp.data.itens.length > 0) {
        this.obs.clientes_length = resp.data.count
        this.obs.clientes = resp.data.itens
      }

      this.obs.waitFornecedores = false;

    } catch (ex) {
      this.obs.waitFornecedores = false;
      toast.error('Erro ao carregar Clientes, tente novamente mais tarde.', {});
    }
  }

  async loadFornecedoresFilter(page: number, text: string) {
    try {
      var re = new RegExp(/[0-9]/g)

      if (re.test(text)) {
        text = text.replace(/\./g, "").replace(/\//g, "").replace(/\-/g, "")
      }

      let params = {
        page: page,
        limit: 20,
        filter: text
      }
      let resp = await api.post("/api/fornecedores", params);

      this.obs.fornecedores = [];
      this.obs.fornecedores_length = 0

      if (resp.data.itens.length > 0) {
        this.obs.fornecedores_length = resp.data.count
        this.obs.fornecedores = resp.data.itens
      }

    } catch (ex) {
      toast.error('Erro ao filtrar Fornecedores, tente novamente mais tarde.', {});
    }
  }

  async loadClientesFilter(page: number, text: string) {
    try {
      var re = new RegExp(/[0-9]/g)

      if (re.test(text)) {
        text = text.replace(/\./g, "").replace(/\//g, "").replace(/\-/g, "")
      }

      let params = {
        page: page,
        limit: 20,
        filter: text
      }
      let resp = await api.post("/api/clientes", params);

      this.obs.clientes = [];
      this.obs.clientes_length = 0

      if (resp.data.itens.length > 0) {
        this.obs.clientes_length = resp.data.count
        this.obs.clientes = resp.data.itens
      }

    } catch (ex) {
      toast.error('Erro ao filtrar Clientes, tente novamente mais tarde.', {});
    }
  }

}

export const FornecedoresStore = new _FornecedoresStore();
